import CycleSummaryPanel from 'src/components/material/DeviceDashboard/CycleSummary/CycleSummaryPanel';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectCyclesByFacilities } from '../summaryDashboardSlice';

const CycleSummaryContainer = () => {
    const { t } = useTranslation("translations");
    const { cycles, deviceTimezone, selectedFacilities } = useSelector(
        // @ts-ignore
        (store) => store.summarydashboard
    );

    const filteredCycles = useSelector((store) => selectCyclesByFacilities(store.summarydashboard, selectedFacilities.map(facility => facility.name)));

    const loading = useSelector((store) => store.summarydashboard.loading.cycleSummary);

    return (
        <CycleSummaryPanel deviceCycles={filteredCycles} deviceTimezone={deviceTimezone} loading={loading} />
    );
};
export default CycleSummaryContainer;

